import type { ComponentType } from 'react';
import React from 'react';

import { getSmartCardRenderers } from '@confluence/fabric-extension-lib/entry-points/getSmartCardRenderers';
import { useSessionData } from '@confluence/session-data';
import { isPageSSRd, useStoreOptions } from '@confluence/content-smartlinks';
import { fg } from '@confluence/feature-gating';
import { ConfluenceSmartCardProvider } from '@confluence/smart-card-provider/entry-points/ConfluenceSmartCardProvider';

export function withSmartCardProviderContext<T>(WrappedComponent: ComponentType<T>) {
	return (props: any) => {
		const { isAdminHubAIEnabled } = useSessionData();

		const isPageSSR = isPageSSRd();
		const initialState = window['__SSR_SMARTLINKS__'];
		const storeOptions = useStoreOptions(initialState, isPageSSR);
		const presetInitialState = fg('platform_ssr_smartlinks_editor') ? storeOptions : {};

		const content = <WrappedComponent {...props} />;

		return (
			<>
				{fg('confluence_smart_card_provider_preview_panel') ? (
					content
				) : (
					<ConfluenceSmartCardProvider
						{...getSmartCardRenderers()}
						{...presetInitialState}
						isAdminHubAIEnabled={isAdminHubAIEnabled}
					>
						{content}
					</ConfluenceSmartCardProvider>
				)}
			</>
		);
	};
}
